module.exports = __webpack_public_path__ + "static/media/TP_CC (Acacia).921b0a43.png";